import { mapActions, mapState } from 'vuex'
import EventBus from '@/eventBus'

export default {
  computed: {
    ...mapState({
      undoHistory: (state) => state.undoHistory,
      redoHistory: (state) => state.redoHistory,
      dataEventBusHistory: (state) => state.dataEventBusHistory,
      mapLockAddHistory: (state) => state.mapLockAddHistory,
      arrKeyLockAddHistory: (state) => state.arrKeyLockAddHistory,
      isLockAddHistory: (state) => state.isLockAddHistory,
    }),
    componentName() {
      return this.$options.name || this.$options._componentTag
    },
  },
  beforeDestroy() {
    if (this.dataEventBusHistory[this.componentName]) {
      EventBus.$off('callFunction', this.callFunction)
      this.$store.state.dataEventBusHistory[this.componentName] = false
    }
  },
  methods: {
    ...mapActions(['blockHistoryAction', 'unblockHistoryAction']),
    registerHistory(componentName) {
      this.historyStoreName = componentName || this.componentName
      if (!this.dataEventBusHistory[this.historyStoreName]) {
        EventBus.$on('callFunction', this.callFunction)
        this.$store.state.dataEventBusHistory[this.historyStoreName] = true
      }
    },
    getFunctionNameForAction(action, type) {
      const method = `${action}${type}`
      if (!this[method]) {
        return `restore${type}`
      }
      return method
    },
    async callFunction({
      payload, componentName, action, type, callback,
    }) {
      if (this.historyStoreName !== componentName) {
        return
      }
      const method = this.getFunctionNameForAction(action, type)
      if (this[method]) {
        let result = false
        try {
          result = await this[method](payload)
        } catch (e) {
          console.log(e)
        }
        callback(result)
      }
    },

    lockHistory(key) {
      this.$store.state.isLockAddHistory++
      this.mapLockAddHistory[key] = {
        data: [],
        status: 0,
      }
      this.arrKeyLockAddHistory.push(key)
    },

    unlockHistory(key, isAdd = true) {
      this.$store.state.isLockAddHistory--
      this.mapLockAddHistory[key].status = 1
      if (!isAdd) {
        return
      }
      if (this.isLockAddHistory === 0) {
        let index = 0
        const arrRemove = []
        // eslint-disable-next-line no-restricted-syntax
        for (const keyLock of this.arrKeyLockAddHistory) {
          const objLock = this.mapLockAddHistory[keyLock]
          if (objLock.status === 1) {
            const arrAddHistories = this.mapLockAddHistory[keyLock].data
            arrAddHistories.forEach((item) => {
              this._addToUndoHistory(item)
            })
            arrRemove.unshift(index)
          }
          index++
        }
        arrRemove.forEach((indexRemove) => {
          this.arrKeyLockAddHistory.splice(indexRemove, 1)
        })
      }
    },

    addActionToHistory(payload, key = null) {
      this.$store.state.redoHistory = []
      // TH bình thường
      if (this.isLockAddHistory === 0) {
        this._addToUndoHistory(payload)
        return
      }
      // TH đã bị lock sẽ thêm vào queue history
      if (!key) {
        const currentKey = this.arrKeyLockAddHistory[this.arrKeyLockAddHistory.length - 1]
        this.mapLockAddHistory[currentKey].data.push(payload)
        return
      }

      // TH lock primary thì sẽ thêm vào đầu
      this.mapLockAddHistory[key].data.unshift(payload)
    },

    _addToUndoHistory(payload) {
      this.undoHistory.push({
        type: payload.type,
        componentName: this.historyStoreName,
        data: payload.data,
        newData: payload.newData,
        slideActiveId: payload.slideActiveId,
      })
    },

  },
}
